// Initialize Announcement Bar (carousel, marquee)
document.addEventListener('DOMContentLoaded', () => {
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();

      this.config = {
        autorotate: this.dataset.autorotate === 'true',
        autorotateSpeed: parseInt(this.dataset.autorotateSpeed) * 1000,
        moveTime: parseFloat(this.dataset.speed),
        space: 100,
      };

      if (theme.config.mqlSmall) {
        this.initOnMobile();
      } else {
        this.initOnDesktop();
      }

      document.addEventListener('matchSmall', () => {
        this.unload();
        this.initOnMobile();
      });

      document.addEventListener('unmatchSmall', () => {
        this.unload();
        this.initOnDesktop();
      });
    }

    initOnDesktop() {
      switch (this.dataset.layout) {
        case 'carousel':
          this.initCarousel();
          break;
        case 'marquee':
          this.initMarquee();
          break;
        default:
          this.initMarqueeOptimized();
      }
    }

    initOnMobile() {
      switch (this.dataset.mobileLayout) {
        case 'carousel':
          this.initCarousel();
          break;
        case 'marquee':
          this.initMarquee();
          break;
      }
    }

    unload() {
      if (this.flickity && typeof this.flickity.destroy === 'function') {
        this.flickity.destroy();
        this.removeNextPrevListeners();
      }

      if (this.classList.contains('marquee')) {
        this.classList.remove('marquee');
        this.querySelectorAll('.announcement-slider[aria-hidden]').forEach((slider) => {
          slider.remove();
        });
      }

      if (this.observer && typeof this.observer.unobserve === 'function') {
        this.observer.unobserve(this);
      }
    }

    initCarousel() {
      if (this.dataset.blockCount == 1) return;

      const slider = this.querySelector('.announcement-slider');
      setTimeout(() => {
        this.flickity = new Flickity(slider, {
          accessibility: false,
          rightToLeft: theme.config.rtl,
          prevNextButtons: false,
          pageDots: false,
          wrapAround: true,
          setGallerySize: false,
          autoPlay: this.config.autorotate ? this.config.autorotateSpeed : false,
        });
      });

      this.prevButton = this.querySelector('button[name="previous"]');
      this.nextButton = this.querySelector('button[name="next"]');

      this.onNextPrevClick = this.handleNextPrevClick.bind(this);
      this.prevButton && this.prevButton.addEventListener('click', this.onNextPrevClick);
      this.nextButton && this.nextButton.addEventListener('click', this.onNextPrevClick);
    }

    removeNextPrevListeners() {
      this.prevButton && this.prevButton.removeEventListener('click', this.onNextPrevClick);
      this.nextButton && this.nextButton.removeEventListener('click', this.onNextPrevClick);
    }

    handleNextPrevClick(event) {
      event.preventDefault();
      const target = event.currentTarget;
      if (target.name === 'next') {
        this.flickity && this.flickity.next();
      } else if (target.name === 'previous') {
        this.flickity && this.flickity.previous();
      }
    }

    initMarqueeOptimized() {
      setTimeout(() => {
        this.marqueeAnimation();
      });

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.isAnimated && this.classList.remove('marquee--paused');
          } else {
            this.isAnimated && this.classList.add('marquee--paused');
          }
        });
      }, { rootMargin: '0px 0px 50px 0px' });

      this.observer.observe(this);
      window.addEventListener('resize', this.marqueeAnimation.bind(this));
    }

    marqueeAnimation() {
      const slider = this.querySelector('.announcement-slider');

      if (slider.scrollWidth > this.clientWidth) {
        if (!this.isAnimated) {
          for (let i = 0; i < 2; i++) {
            const clone = slider.cloneNode(true);
            clone.setAttribute('aria-hidden', true);
            this.appendChild(clone);
          }
          this.classList.add('marquee');
          this.style.setProperty('--duration', `${(slider.scrollWidth / this.config.space) * this.config.moveTime}s`);
          this.isAnimated = true;
        }
      } else if (this.isAnimated) {
        for (let i = 0; i < 2; i++) {
          this.removeChild(this.lastElementChild);
        }
        this.classList.remove('marquee');
        this.isAnimated = false;
      }
    }

    initMarquee() {
      setTimeout(() => {
        const slider = this.querySelector('.announcement-slider');
        for (let i = 0; i < 10; i++) {
          const clone = slider.cloneNode(true);
          clone.setAttribute('aria-hidden', true);
          this.appendChild(clone);
        }
        this.classList.add('marquee');
        this.style.setProperty('--duration', `${(slider.clientWidth / this.config.space) * this.config.moveTime}s`);
      });

      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.classList.remove('marquee--paused');
          } else {
            this.classList.add('marquee--paused');
          }
        });
      }, { rootMargin: '0px 0px 50px 0px' });

      this.observer.observe(this);
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);
});


// Initialize Announcement Bar Menu (dropdown + scroll-close)
document.addEventListener('DOMContentLoaded', () => {
  class AnnouncementBarMenu extends HTMLElement {
    constructor() {
      super();
      this.detailsElements = this.querySelectorAll('details');
      this.handleScroll = this.closeAll.bind(this);
    }

    connectedCallback() {
      this.detailsElements.forEach((details) => {
        details.addEventListener('toggle', () => {
          if (details.open) {
            this.closeOthers(details);
          }
        });
      });

      window.addEventListener('scroll', this.handleScroll);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.handleScroll);
    }

    closeOthers(currentDetails) {
      this.detailsElements.forEach((details) => {
        if (details !== currentDetails) {
          details.removeAttribute('open');
        }
      });
    }

    closeAll() {
      this.detailsElements.forEach((details) => {
        details.removeAttribute('open');
      });
    }
  }

  customElements.define('announcement-bar-menu', AnnouncementBarMenu);
});
